import { QUERY_KEYS } from "@forwardflow/helpers/utils/constants";
import OrganizationService from "@forwardflow/services/OrganizationService";

import useSWR from "swr";

export function useBusinessHoursData() {
  const response = useSWR([QUERY_KEYS.BUSINESS_HOURS], () =>
    OrganizationService.getBusinessHourData()
  );
  return {
    ...response,
  };
}
